module.exports = __webpack_public_path__ + "afdde23b87fbb7467362a13959e28426.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/step-1.png
// module id = 168
// module chunks = 0 1